import { providerName } from '../gpu/format'
import { decodeRoleParam } from './routeParam'

interface DocumentTitleOptions {
  autoGeneratedTitle: string
  resource?: { name?: string }
  action?: string
  params?: Record<string, string | undefined>
}

export function getDocumentTitle({
  autoGeneratedTitle,
  resource,
  action,
  params,
}: DocumentTitleOptions): string {
  if (resource?.name === 'roles' && action === 'show' && params?.id) {
    return `${decodeRoleParam(params.id)} | Fluence Admin`
  }
  if (resource?.name === 'gpu-providers' && action === 'show' && params?.key) {
    return `${providerName(params.key)} · GPU provider | Fluence Admin`
  }
  if (resource?.name === 'gpu-instances' && action === 'show') {
    return 'GPU instance | Fluence Admin'
  }
  if (resource?.name === 'gpu-reports')
    return 'Reports to vodopad | Fluence Admin'
  return autoGeneratedTitle.replace('Refine', 'Fluence Admin')
}
